import { h } from "preact";
import { useText } from "preact-i18n";
import styles from "./style.module.scss";
import LoadingIcon from "icons/LoadingIcon";
import Filters from "components/Filters/Filters";
import FilterMultiSelect from "components/Filters/FilterMultiSelect/FilterMultiSelect";
import FilterRangeSlider from "components/Filters/FilterRangeSlider/FilterRangeSlider";
import FilterCheckboxes from "components/Filters/FilterCheckBoxes/FilterCheckBoxes";
import {
    houseTypeList,
    houseTypeListDE,
    buyRatioValues,
    houseHoldTypes,
    housePriceTypes,
    buildingUsage,
    buildYears,
    buildingSizes,
    livingAreas,
    purchasingPowerClasses,
} from "services/constants";
import type MvInputParams from "models/MvInputParams";
import type DefaultOptions from "models/DefaultOptions";
import type { CountryCode } from "models/CountryCode";
interface Props {
    addressId: string;
    params: MvInputParams;
    isOpen: boolean;
    isFetching: boolean;
    countryCode?: CountryCode;
    defaultOptions: DefaultOptions;
    onUpdateParams(id: string, patch: Partial<MvInputParams>): void;
}
const AreaFilters = ({
    addressId,
    params,
    isOpen,
    isFetching,
    countryCode,
    defaultOptions,
    onUpdateParams,
}: Props) => {
    const { radiusLabel, houseValueLabel } = useText({
        radiusLabel: "general.labels.radiusLabel",
        houseValueLabel: "general.labels.houseValueLabel",
    });
    return (
        <div className={styles.mvAreaFilters}>
            {isFetching && (
                <div className={styles.mvLoadingOverlay}>
                    <LoadingIcon
                        fill={"#14456b"}
                        className={styles.mvLoadingIcon}
                    />
                </div>
            )}

            <Filters
                isOpen={isOpen}
                addressId={addressId}
                params={params}
                countryCode={countryCode}
                onUpdateParams={onUpdateParams}
            >
                {/* filter: values / onchange / addressID are injected via Filters */}

                <FilterRangeSlider
                    countryCode={"all"}
                    fieldName="radius"
                    step={10}
                    label={radiusLabel}
                    minValue={10}
                    maxValue={defaultOptions.maxRadius}
                    isSingle
                    hasInputs
                />

                <FilterRangeSlider
                    countryCode={"nl"}
                    step={10}
                    minValue={10}
                    maxValue={2000}
                    fieldName="houseValue"
                    label={houseValueLabel}
                    hasInputs
                />

                <FilterMultiSelect
                    countryCode={"all"}
                    labelId="filters.buildingType.label"
                    fieldName="houseType"
                    defaultSelectAll={countryCode === "de"}
                    half={countryCode === "de"}
                    options={
                        countryCode === "de" ? houseTypeListDE : houseTypeList
                    }
                />

                <FilterMultiSelect
                    countryCode={"de"}
                    labelId="filters.buildingUsage.label"
                    fieldName="buildingUsage"
                    half={true}
                    options={buildingUsage}
                />

                <FilterCheckboxes
                    countryCode={"nl"}
                    labelId="general.labels.filterOn"
                    fieldName="housePriceType"
                    options={housePriceTypes}
                />

                {/* <FilterConditionalRangeSlider
                        countryCode={"de"}
                        labelId="general.labels.buyRatioLabel"
                        fieldName="buyRatio"
                        value={params?.buyRatio}
                        defaultValue={2}
                        minValue={1}
                        maxValue={4}
                        customValues={buyRatioValues}
                        isSingle
                        hasInputs={false}
                    /> */}

                <FilterMultiSelect
                    more={true}
                    half={true}
                    countryCode={"de"}
                    labelId="filters.buyRatio.label"
                    fieldName="buyRatio"
                    options={buyRatioValues}
                />

                <FilterMultiSelect
                    more={true}
                    half={true}
                    countryCode={"de"}
                    labelId="filters.buildYear.label"
                    fieldName="buildYear"
                    options={buildYears}
                />

                <FilterMultiSelect
                    more={true}
                    half={true}
                    countryCode={"de"}
                    labelId="filters.buildingSize.label"
                    fieldName="buildingSize"
                    options={buildingSizes}
                />

                <FilterMultiSelect
                    more={true}
                    half={true}
                    countryCode={"de"}
                    labelId="filters.livingArea.label"
                    fieldName="livingArea"
                    options={livingAreas}
                />

                <FilterMultiSelect
                    more={true}
                    half={false}
                    countryCode={"de"}
                    labelId="filters.purchasingPowerClass.label"
                    fieldName="purchasingPowerClass"
                    options={purchasingPowerClasses}
                />

                {/* <FilterMultiSelect
                        more={true}
                        half={true}
                        countryCode={"de"}
                        labelId="filters.residenceLength.label"
                        fieldName="residenceLength"
                        options={residenceLengths}
                    />
                    */}

                <FilterCheckboxes
                    more={true}
                    countryCode={"de"}
                    labelId="filters.household.label"
                    fieldName="household"
                    stacked
                    options={houseHoldTypes}
                />
            </Filters>
        </div>
    );
};
export default AreaFilters;
